import { render, staticRenderFns } from "./CertificationTippaniPrint.vue?vue&type=template&id=3405b120&scoped=true&"
import script from "./CertificationTippaniPrint.vue?vue&type=script&lang=js&"
export * from "./CertificationTippaniPrint.vue?vue&type=script&lang=js&"
import style0 from "./CertificationTippaniPrint.vue?vue&type=style&index=0&id=3405b120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3405b120",
  null
  
)

export default component.exports